// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"af180bb6","outerContainer":"e5160196","secondaryToolbar":"_1084abbc","doorHangerRight":"f68ec5bc","toolbarContainer":"_751c86cf","toolbarViewerMiddle":"ba80f0a1","progressBar":"a72ab1c6","back-to-application":"_2ea1af4c","about":"_47aefc4e","about__moderators":"_4e2163cf","description":"_4464a12d","description__text":"_97e47c1b","description__button":"cf306b7d","list":"_6b0a08b8","list-item":"cd076332","list__header":"cf3569fc","list-item__icon":"d5116caf","full-list":"_3606b45b","full-list__item":"b573527f","full-list__item-mobile":"_54b71a46","full-list-mobile":"_500c290f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Community/About/index.styl
// module id = 718
// module chunks = 39